/* eslint-disable */
// MissingFieldsPopup — in-modal "required fields missing" popup. Pulsing alert
// ring + count + clickable field chips (each calls its onJump to focus/scroll
// the field) + "Review fields" button. Rendered inside the modal card (over the
// body), driven by an array of { label, onJump }. Tokens via .createDnaRoot.
import React from 'react';
import styles from './MissingFieldsPopup.module.css';

export default function MissingFieldsPopup({ fields = [], onReview, onClose }) {
  if (!fields || fields.length === 0) return null;
  return (
    <div className={styles.overlay} onClick={(e) => { if (e.target === e.currentTarget) onClose && onClose(); }}>
      <div className={styles.popup} role="alertdialog" aria-label="Required fields missing">
        <div className={styles.icon} aria-hidden="true">
          <span className={styles.ring} />
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 9v4" /><path d="M12 17h.01" /><path d="M10.3 3.6 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.6a2 2 0 0 0-3.4 0z" />
          </svg>
        </div>
        <div className={styles.title}>{fields.length} required field{fields.length === 1 ? '' : 's'} missing</div>
        <div className={styles.sub}>Fill these in to continue — click one to jump to it.</div>
        <div className={styles.chips}>
          {fields.map((f) => (
            <button
              key={f.label}
              type="button"
              className={styles.chip}
              onClick={() => { if (f.onJump) f.onJump(); if (onClose) onClose(); }}
            >
              {f.label}
            </button>
          ))}
        </div>
        <button type="button" className={styles.review} onClick={onReview || onClose}>Review fields</button>
      </div>
    </div>
  );
}
